<template>
    <div class="page">
        <div class="content-wrap">
            <div class="pic-wrap about-img-wrap">
                <img :src="dataSources.about" :alt="dataSources.system_name" class="pic-img about-img" />
            </div>
        </div>
        <!-- <div class="content">
            <div class="title td-fcc">
                <span>关于我们</span>
            </div>
            <div class="tips td-fc td-fcc">
                <img class="logo" :src="dataSources.system_logo || Images.icon_logo" />
                <span>{{dataSources.system_name}}</span>
            </div>
            <div class="phone">
                <div class="td-f">
                    <img :src="Images.icon_user_white" />
                    <span>联系电话：</span>
                    <span class="td-f1">{{dataSources.contact_us}}</span>
                </div>
                <div class="td-f">
                    <img :src="Images.icon_location_white" />
                    <span>联系地址：</span>
                    <span class="td-f1">{{dataSources.address}}</span>
                </div>
            </div>
        </div>
        <div class="footer">
            <img :src="Images.img_about_us" >
        </div> -->
    </div>
</template>
<script>
export default {
    /** 数据区 */
    data() {
        return {
            dataSources: {},
        };
    },
    /** 加载前 */
    created() {
        this.requestDataTab()
    },
    /** 方法 */
    methods: {
        // 请求数据
        async requestDataTab() {
            let url = this.API.about;
            let params = {
                code: "base"
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.page {
    overflow: hidden;
    min-height: 100vh;
    background-color: #fff;
    background-size: 100% auto;
}

.content-wrap {
    position: relative;
    border-radius: 4px 4px 0 0;
    .about-img {
        width: 100%;
        height: 100vh;
        object-fit: fill;
    }
}

.content {
    margin: 40px 15px 0;
    background-color: #fff;
    border-radius: 4px 4px 0 0;
    padding: 60px 10px 50px;
    position: relative;

    .title {
        position: absolute;
        top: -13px;
        left: 50%;
        transform: translateX(-50%);
        width: 208px;
        height: 48px;
        background-image: url('../../assets/img/img_bg_aboutus_title.png');
        background-size: 100% 100%;

        span {
            font-size: 18px;
            color: #ffffff;
            font-weight: 500;
            background-image: url('../../assets/img/img_bg_aboutus_title_text.png');
            background-size: 100% 100%;
            padding: 0 20px;
        }
    }

    .tips {
        font-size: 14px;
        text-align: center;
        color: #333333;

        .logo {
            width: 60px;
            height: 60px;
            object-fit: contain;
            margin-bottom: 10px;
        }

        span {
            font-weight: bold;
            letter-spacing: 1px;
        }
    }

    .phone {
        margin-top: 50px;
        min-height: 50px;
        background-image: url('../../assets/img/img_bg_aboutus_contact.jpg');
        background-size: 100% 100%;
        padding: 10px;

        >div {
            padding: 5px 0;
        }

        span {
            font-size: 13px;
            color: #ffffff;
            font-weight: 600;
            line-height: 20px;
            text-align: justify;
        }

        img {
            width: 16px;
            height: 16px;
            display: block;
            object-fit: contain;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
}

.footer {
    margin: 0 15px;

    img {
        width: 100%;
    }
}
</style>